import { render } from "./NewClass.vue?vue&type=template&id=6fb8861e&scoped=true"
import script from "./NewClass.vue?vue&type=script&lang=js"
export * from "./NewClass.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./NewClass.vue?vue&type=style&index=1&id=6fb8861e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb8861e"]])

export default __exports__